module.exports = __webpack_public_path__ + "static/media/9DESA22.4f72bfe0.jpg";